






































    import {Component, Prop, Vue, Watch} from "vue-property-decorator";
    import DataTable from "@/components/DataTable.vue";
    import {Guid} from "guid-typescript";
    import {TimestampCache} from "@/store/cache";
    import {
        emptyPaginatedList,
        ErrorToastSettings,
        FilteredQueryRequest,
        IFilteredQueryRequest,
        IPaginatedList,
        SuccessToastSettings
    } from "@/api/Utils";
    import {Getter} from "vuex-class";
    import {ITableColumn} from "@/components/helpers/ITableColumn";
    import UpdateIcon from "@/components/helpers/UpdateIcon.vue";
    import Check from "@/components/helpers/Check.vue";
    import DeleteIcon from "@/components/helpers/DeleteIcon.vue";
    import Modal from "@/components/Modal.vue";
    import {Webhook, WebhookApi} from "@/api/v1/WebhookApi";

    @Component({components: {Check, UpdateIcon, DeleteIcon, DataTable, Modal}})
    export default class WebhookSubscriptionTable extends Vue {
        @Prop({type: String, required: true}) readonly clientId!: Guid;

        @Getter tstpCache!: TimestampCache;

        dataProvider: Promise<IPaginatedList<Webhook>> = Promise.resolve(emptyPaginatedList());
        query: IFilteredQueryRequest = new FilteredQueryRequest(1, 25, "id");
        deleting: Webhook | null = null;

        get columns(): ITableColumn[] {
            return [
                {label: "URL", key: "url", sortable: true},
                {label: "", key: "rowActions", sortable: false}
            ];
        }

        @Watch("tstpCache.webhooks")
        refresh() {
            this.dataProvider = WebhookApi.find(this.clientId, this.query);
        }

        queryChange(query: IFilteredQueryRequest) {
            this.query = query;
            this.refresh();
        }

        create() {
            this.$router.push({name: "createWebhook"});
        }

        confirmDelete(item: Webhook) {
            this.deleting = item;
        }

        deleteWebhook() {
            if (this.deleting) {
                WebhookApi.delete(this.clientId, this.deleting.id)
                    .then(() => {
                        this.$bvToast.toast(this.$t("webhook-deleted").toString(), SuccessToastSettings);
                        this.deleting = null;
                        this.refresh();
                    })
                    .catch(err => {
                        this.$bvToast.toast(this.$t("failed-delete-webhook").toString(), ErrorToastSettings);

                        throw err;
                    });
            }
        }

        closeModal() {
            this.deleting = null;
        }
    }
